import { useQuery } from '@tanstack/react-query';

import { QueryFnData, UseQueryOpts } from '../../engine';
import { channelLinkMany, siteLinkMany } from './key-fn';

type ChannelLinkMany = typeof channelLinkMany;
export type ChannelLinkManyData = QueryFnData<ChannelLinkMany>;
export const useChannelLinkMany = <SelectedData = QueryFnData<ChannelLinkMany>>(
  params: Parameters<ChannelLinkMany>[0],
  options?: Omit<UseQueryOpts<ChannelLinkMany, SelectedData>, 'initialData'>,
) => {
  return useQuery({
    ...channelLinkMany(params),
    ...options,
  });
};

type SiteLinkMany = typeof siteLinkMany;
export type SiteLinkManyData = QueryFnData<SiteLinkMany>;
export const useSiteLinkMany = <SelectedData = QueryFnData<SiteLinkMany>>(
  params: Parameters<SiteLinkMany>[0],
  options?: Omit<UseQueryOpts<SiteLinkMany, SelectedData>, 'initialData'>,
) => {
  return useQuery({
    ...siteLinkMany(params),
    ...options,
  });
};
